/* cc-lockscroll.js
   Intent-based scroll lock for horizontal carousels.
   - Blocks vertical page scroll ONLY while user is actively swiping horizontally
   - Preserves native clicks on desktop / tablet
   - Safe for multiple instances
*/

(function () {
  if (window.__cxCcLockScrollInit) return;
  window.__cxCcLockScrollInit = true;

  var SELECTOR = '[data-cx-lockscroll="true"]';
  var INTENT_MARGIN = 6;
  var START_DEADBAND = 2;
  var ACTIVE_CLASS = 'cx-lockscroll-active';

  function abs(n) { return n < 0 ? -n : n; }

  function getTouchById(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].identifier === id) return list[i];
    }
    return null;
  }

  function attach(el) {
    if (!el || el.__cxLockScrollAttached) return;
    el.__cxLockScrollAttached = true;

    var state = {
      active: false,
      locked: false,
      intent: null,
      sx: 0,
      sy: 0,
      pointerId: null,
      pointerType: null,
      touchId: null
    };

    function reset() {
      state.active = false;
      state.locked = false;
      state.intent = null;
      state.pointerId = null;
      state.pointerType = null;
      state.touchId = null;
      el.classList.remove(ACTIVE_CLASS);
    }

    function classify(dx, dy) {
      if (abs(dx) < START_DEADBAND && abs(dy) < START_DEADBAND) return null;
      if (abs(dx) > abs(dy) + INTENT_MARGIN) return 'h';
      if (abs(dy) > abs(dx) + INTENT_MARGIN) return 'v';
      return null;
    }

    function lock() {
      state.locked = true;
      el.classList.add(ACTIVE_CLASS);
    }

    function unlock() {
      reset();
    }

    /* ---------------- TOUCH (mobile priority) ---------------- */

    function onTouchStart(e) {
      if (!e.touches || !e.touches.length) return;
      var t = e.touches[0];
      state.active = true;
      state.intent = null;
      state.locked = false;
      state.touchId = t.identifier;
      state.sx = t.clientX;
      state.sy = t.clientY;
    }

    function onTouchMove(e) {
      if (!state.active || state.touchId === null) return;
      var t = getTouchById(e.touches, state.touchId);
      if (!t) return;

      var dx = t.clientX - state.sx;
      var dy = t.clientY - state.sy;

      if (!state.intent) {
        var intent = classify(dx, dy);
        if (intent) {
          state.intent = intent;
          if (intent === 'h') lock();
        }
      }

      if (state.intent === 'h' && state.locked) {
        e.preventDefault();
      }
    }

    function onTouchEnd() {
      if (!state.active) return;
      unlock();
    }

    /* ---------------- POINTER (desktop / tablet) ---------------- */

    function onPointerDown(e) {
      if (e.button != null && e.button !== 0) return;

      state.active = true;
      state.intent = null;
      state.locked = false;
      state.pointerId = e.pointerId;
      state.pointerType = e.pointerType || 'mouse';
      state.sx = e.clientX;
      state.sy = e.clientY;

      // ❌ NEVER capture mouse pointers — it kills clicks
      if (state.pointerType !== 'mouse') {
        try { el.setPointerCapture(e.pointerId); } catch (_) {}
      }
    }

    function onPointerMove(e) {
      if (!state.active || e.pointerId !== state.pointerId) return;

      var dx = e.clientX - state.sx;
      var dy = e.clientY - state.sy;

      if (!state.intent) {
        var intent = classify(dx, dy);
        if (intent) {
          state.intent = intent;
          if (intent === 'h') lock();
        }
      }

      // Only preventDefault for non-mouse pointers
      if (state.intent === 'h' && state.locked && state.pointerType !== 'mouse') {
        e.preventDefault();
      }
    }

    function onPointerUp() {
      unlock();
    }

    /* ---------------- SAFETY ---------------- */

    function onBlur() { unlock(); }
    function onVisibility() {
      if (document.visibilityState !== 'visible') unlock();
    }

    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    el.addEventListener('touchend', onTouchEnd, { passive: true });
    el.addEventListener('touchcancel', onTouchEnd, { passive: true });

    el.addEventListener('pointerdown', onPointerDown, { passive: true });
    el.addEventListener('pointermove', onPointerMove, { passive: false });
    el.addEventListener('pointerup', onPointerUp, { passive: true });
    el.addEventListener('pointercancel', onPointerUp, { passive: true });

    window.addEventListener('blur', onBlur);
    document.addEventListener('visibilitychange', onVisibility);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(attach);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
